import { getWindow } from '@shared/services/window';
const redirectLoginSuffix = ()=>{
    var _getWindow, _getWindow1, _getWindow2;
    const isHttps = ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.port) === '443' || ((_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : _getWindow1.location.protocol) === 'https:';
    const retVal = !isHttps && `:${(_getWindow2 = getWindow()) === null || _getWindow2 === void 0 ? void 0 : _getWindow2.location.port}` || '';
    return retVal;
};
export const getRedirectLoginUrl = ()=>{
    var _getWindow, _getWindow1;
    return `${(_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location.protocol}//${(_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : _getWindow1.location.hostname}${redirectLoginSuffix()}`;
};
